// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"00c83437","502":"f23fa298","573":"8ad6b657","653":"05a16676","835":"05ddc7c0"}[chunkId] + ".chunk.css";
};